__turbopack_context__.v({
  "icon": "search-button-module-scss-module__fg22wW__icon",
});
